import { forEach, isNil, omitBy } from 'lodash-es';

import { HttpParams } from '@angular/common/http';

import { MetadataQueryParamsBase } from '@bp/shared/models/metadata';
import { toPlainObject } from '@bp/shared/utilities/core';
import { Dictionary } from '@bp/shared/typings';

export function toHttpParams(query?: MetadataQueryParamsBase): HttpParams | undefined {
	if (!query)
		return undefined;

	const params = <Dictionary<any>>omitBy(toPlainObject(query), isNil);

	let httpParams = new HttpParams({ fromObject: params });

	forEach(params, (value, key) => {
		if (Array.isArray(value))
			httpParams = httpParams.set(key, value.join(','));
	});

	return httpParams;
}
